import script from "./JBoxForm.vue?vue&type=script&setup=true&lang=js"
export * from "./JBoxForm.vue?vue&type=script&setup=true&lang=js"

import "./JBoxForm.vue?vue&type=style&index=0&id=98eb81b6&lang=css"

const __exports__ = script;

export default __exports__